export const COURSES = "courses";
export const BLOGS = "blogs";
export const EBOOKS = "ebooks";

export const PAISE = "paise";
export const RUPEES = "rupees";

export const WEEKLY = "weekly";
export const MONTHLY = "monthly";
export const YEARLY = "yearly";

export const ADMIN = "administration";
export const DEV = "development";